var map = {
	"./de/btn-view.png": "f82f",
	"./en/btn-view.png": "kxrL",
	"./es/btn-view.png": "eFps",
	"./fr/btn-view.png": "36tU",
	"./ja/btn-view.png": "rkuP",
	"./ko/btn-view.png": "bd7r",
	"./pt/btn-view.png": "0NeL",
	"./ru/btn-view.png": "83RQ",
	"./tc/btn-view.png": "5o46",
	"./th/btn-view.png": "OImp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W4JQ";